document.addEventListener("DOMContentLoaded", () => {
  // Delay slightly to let Ultra initialise its player
  setTimeout(() => {
    const videos = document.querySelectorAll(".product-gallery-video__html");

    videos.forEach(video => {
      // Force attributes every time Ultra resets the player
      video.setAttribute("muted", "true");
      video.muted = true;
      video.setAttribute("autoplay", "true");
      video.setAttribute("playsinline", "true");
      video.setAttribute("loop", "true");

      // Try to play once ready
      const playVideo = () => {
        video.play().catch(() => {});
      };

      video.addEventListener("canplay", playVideo);
      if (video.readyState >= 3) playVideo();

      // Ultra re-renders on slide change; re-run play then too
      const observer = new MutationObserver(() => {
        if (!video.paused) return;
        playVideo();
      });
      observer.observe(video, { attributes: true });
    });
  }, 1200); // wait ~1s for Ultra to finish its lazy setup
});
